<script>
import Dashboard from '@/views/srds/Dashboard'

export default {
  name: 'SMARCLEBoard',
  extends: Dashboard,
}
</script>
